export default "__VITE_ASSET__16f73b0e__"